import React, { useEffect, useState } from "react";
import {
  CheckBoxInput,
  DateInput,
  SelectInput,
} from "../../components/common/ui/Inputs";
import {
  fDate,
  getCurrentDate,
  IOSCheckDate,
  MinDate,
} from "../../utils/formatTime.js";
import DatePickerComponent from "../../components/common/ui/Inputs/DateInput.jsx";
import activeIcon from "../../assets/svg/approved.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import deleteicon from "../../assets/svg/delete-icon.svg";
import fileReplicate from "../../assets/replicate.svg";
import { history } from "../../_helpers";
import { useDispatch, useSelector } from "react-redux";
import { noticeAction } from "../../_store/notice.slice.js";
import { masterActions, authActions } from "../../_store";
import { photoAction } from "../../_store/photo.slice.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { Popup } from "../../components/common/ui/NotificationModal/Popup.js";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal.js";
import {
  MenuItem,
  UserRoleType,
  StoredProcedures,
} from "../../_helpers/enumerator";
import Swal from "sweetalert2";
import noticeListSchema from "../../validation/noticeListSchema.jsx";
import MultiSelectDropdown from "../../components/common/ui/Inputs/MultiSelectDropdown.jsx";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";

function NoticeList() {
  const dispatch = useDispatch();

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const loggedUser = useSelector((x) => x?.auth?.user);
  const { podStatusOptions } = useSelector((x) => x?.dropdownOptions);
  const [isreplicateClearable, setisreplicateClearable] = useState(false);
  const [isClearable, setIsClearable] = useState(false);

  const {
    noticeListResponse,
    loading,
    deleteResponse,
    facilityListForExportNotice,
    exportNoticeData,
    submitExportNoticeResponse,
    replicateNoticeData,
    replicateNoticeResponse,
    noticeSearchdata,
  } = useSelector((x) => x?.notice);
  const KIOSKDropDownResponse = useSelector(
    (x) => x?.notice?.KIOSKDropDownResponse
  );

  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  // Getting user details
  const { user } = useSelector((x) => x.auth);
  const [submit, setSubmit] = useState(false);

  //Management User Access Permission selector
  const userAccessPermission = useSelector(
    (state) => state.auth.managementUserAccessPermission
  );

  // Hide or Show Add Notices button
  const shouldShowBtnAdd =
    Array.isArray(userAccessPermission) && userAccessPermission.length > 0
      ? userAccessPermission.some(
        (item) =>
          item?.SubMenuName === "Add" && item?.SubMenuActiveStatus === 1
      )
      : true;

  // Enabled or Disabled modify Notices option in grid
  const shouldEnableModifyOption =
    Array.isArray(userAccessPermission) && userAccessPermission.length > 0
      ? userAccessPermission.some(
        (item) =>
          item?.SubMenuName === "Modify" && item?.SubMenuActiveStatus === 1
      )
      : true;

  // const [noticeSearch, setNoticeSearch] = useState(noticeSearchdata);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});

  const [exportSelectAll, setExportSelectAll] = useState(false);
  const [selectedExport, setSelectedExport] = useState([]);

  // useEffect(() => {
  //   setNoticeSearch(noticeSearchdata);
  // }, [noticeSearchdata]);

  useEffect(() => {
    dispatch(
      noticeAction.setNoticeSearch({
        ...noticeSearchdata,
        facilityID: facilityCode,
      })
    );
    if (facilityCode === 0) return;
    const searchData = { ...noticeSearchdata };
    searchData.facilityID = facilityCode;
    dispatch(noticeAction.noticeList(searchData));
  }, [facilityCode, isPageReloading]);

  useEffect(() => {
    if (facilityCode === 0) return;
    getKioskDropDown();
  }, [facilityCode]);


  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  //delete response
  useEffect(() => {
    switch (deleteResponse?.IsSucceed) {
      case 1:
        showToastNotification("Notice Deleted Successfully...", "success");
        dispatch(noticeAction?.clearDeleteResponse());
        // getNoticeList();
        const searchData = { ...noticeSearchdata };
        // searchData.facilityID = facilityCode;
        // searchData.pageNo = 1;
        // searchData.rowCountPerPage = 10;
        // dispatch(noticeAction.setNoticeSearch(searchData));
        dispatch(noticeAction.noticeList(searchData))
          .then((result) => {
            if (result?.payload?.DataList?.length === 0) {
              const searchParams = { ...noticeSearchdata };
              searchParams.pageNo = 1;
              searchParams.rowCountPerPage = 10;
              dispatch(noticeAction.setNoticeSearch(searchParams));
              dispatch(noticeAction.noticeList(searchParams));
            }
          })
          .catch((err) => { });
        break;

      default:
        break;
    }
  }, [deleteResponse]);

  //submit export notice
  useEffect(() => {
    switch (submitExportNoticeResponse?.IsSucceed) {
      case 1:
        showToastNotification("Notices Exported Successfully", "success");
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;
      case 2:
        showToastNotification("Notices Exported Successfully", "success");
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;

      case -2:
        showToastNotification("No Notices to Export", "warning");
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;

      case 0:
        showToastNotification("Failed to Export Notice List", "error");
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;

      default:
        break;
    }
  }, [submitExportNoticeResponse]);

  //replicate notice response
  useEffect(() => {
    switch (replicateNoticeResponse?.IsSucceed) {
      case 1:
        showToastNotification(
          "Notice information has been updated successfully",
          "success"
        );
        dispatch(noticeAction.clearResponse());
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;
      case -1:
        showToastNotification("Error in insert or update", "success");
        dispatch(noticeAction.clearResponse());
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;

      case -2:
        showToastNotification("No Kiosk is been selected", "warning");
        dispatch(noticeAction.clearResponse());
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;

      case -3:
        showToastNotification("Notice title already exists", "warning");
        dispatch(noticeAction.clearResponse());
        dispatch(noticeAction.clearExportNoticeDataResponse());
        break;

      default:
        break;
    }
  }, [replicateNoticeResponse]);



  //Get Management User Access Permission list
  useEffect(() => {
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.NoticesMenuItem,
      })
    );
  }, [dispatch]);

  const getKioskDropDown = () => {
    dispatch(noticeAction.KIOSKDropDown(facilityCode));
  };

  const getNoticeList = () => {
    const searchData = { ...noticeSearchdata };
    searchData.facilityID = facilityCode;
    dispatch(noticeAction.noticeList(searchData))
      .then((result) => {
        if (result?.payload?.DataList?.length === 0) {
          const searchParams = { ...noticeSearchdata };
          searchParams.pageNo = 1;
          searchParams.rowCountPerPage = 10;
          dispatch(noticeAction.setNoticeSearch(searchParams));
          dispatch(noticeAction.noticeList(searchParams));
        }
      })
      .catch((err) => {
        showToastNotification("Error in fetching Notice List", "error");
      });
  };

  const columns = [
    {
      name: "Title",
      selector: (row) => row.NoticeTitle,
      key: "NoticeTitle",
      sortable: true,
      cell: (row) => (
        <div
          onClick={() =>
            shouldEnableModifyOption && navigateToNoticeEdit(row?.NoticeID)
          }
          className={`${shouldEnableModifyOption ? "Common_Link_Style" : ""}`}
        >
          {row.NoticeTitle}
        </div>
      ),
    },
    {
      name: "Start From",
      selector: (row) => row.StartDate,
      sortable: true,
      key: "StartDate",
    },
    {
      name: "End By",
      selector: (row) => row.EndDate,
      sortable: true,
      key: "EndDate",
    },

    // {
    //   width: "130px",
    //   name: "Status",
    //   selector: (row) => row.ActiveStatus,
    //   sortable: true,
    //   center: true,
    //   cell: (row) =>
    //     row.ActiveStatus === "Active" ? (
    //       <span className="status-open">Active</span>
    //     ) : (
    //       <span className="status-Closed">InActive</span>
    //     ),
    //   sortable: true,
    // },////
    {
      name: "Status",
      selector: (row) => row.ActiveStatus,
      key: "ActiveStatus",
      cell: (row) => {
        return (
          <img
            src={row.ActiveStatus === "Active" ? activeIcon : inactiveIcon}
            alt={row.ActiveStatus === "Active" ? "Active" : "Inactive"}
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed
            title={row.ActiveStatus === "Active" ? "Active" : "Inactive"}
          />
        );
      },
      sortable: true,
      center: true,
    },
    // Conditionally add the "Action" column based on UserRoleID
    ...(user.UserRoleID === UserRoleType.SuperAdmin
      ? [
        {
          name: "Action",
          selector: (row) => row.ActiveStatus,
          cell: (row) => (
            <div className="d-flex flex-wrap gap-4">
              <div
                data-bs-toggle="modal"
                data-bs-target="#replicate-notices"
                onClick={() => {
                  handleExportNotice(row);
                  setisreplicateClearable(false);
                }}
              >
                <img
                  src={fileReplicate}
                  title="Replicate to All"
                  aria-hidden="true"
                  className="in-icon-size cursor-pointer"
                  alt="replicate_img"
                />
              </div>
              <img
                src={deleteicon}
                title="Delete"
                alt="Delete"
                aria-hidden="true"
                onClick={() => {
                  handleDelete(row.NoticeID);
                }}
                className="in-icon-size cursor-pointer"
              />
            </div>
          ),
          sortable: false,
          // center: true,
          // right: true,
          // left: true,
        },
      ]
      : []),
  ];

  // const handleChangeForDate = (input, date) => {
  //     const data = { ...noticeData };

  //     if (!date) {
  //         data[input] = "";
  //     } else {
  //       const selectedDate = date instanceof Date ? date : new Date(date);

  //       const formattedDate =
  //           `${String(selectedDate.getMonth() + 1).padStart(2, "0")}/` +
  //           `${String(selectedDate.getDate()).padStart(2, "0")}/` +
  //           `${selectedDate.getFullYear()}`;

  //       data[input] = formattedDate;
  //         if (input === "StartDate") {
  //             data["StartDate"] = formattedDate;

  //             if (data["EndDate"] && new Date(selectedDate) > new Date(data["EndDate"])) {
  //                 data["EndDate"] = "";
  //             }
  //         } else if (input === "EndDate") {
  //             data["EndDate"] = formattedDate;

  //             if (data["StartDate"] && new Date(selectedDate) < new Date(data["StartDate"])) {
  //                 data["EndDate"] = "";
  //             }
  //         } else {
  //             data[input] = formattedDate;
  //         }
  //     }

  //     dispatch(noticeAction.setNoticeData({ ...data }));
  // };

  const handleEnterKey = (event, name) => {
    const regex = /^[0-9/]$/; // Allow numbers and "/"
    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleChangeForDate = (input, date) => {
    let formattedDate = "";

    if (date) {
      const selectedDate = date instanceof Date ? date : new Date(date);
      formattedDate =
        `${String(selectedDate.getMonth() + 1).padStart(2, "0")}/` +
        `${String(selectedDate.getDate()).padStart(2, "0")}/` +
        `${selectedDate.getFullYear()}`;
    }

    const updatedData = { ...replicateNoticeData, [input]: formattedDate };

    if (
      input === "replicateStartDate" &&
      updatedData.replicateEndDate &&
      new Date(updatedData.replicateStartDate) >
      new Date(updatedData.replicateEndDate)
    ) {
      updatedData.replicateEndDate = "";
    }
    if (
      input === "replicateEndDate" &&
      updatedData.replicateStartDate &&
      new Date(updatedData.replicateEndDate) <
      new Date(updatedData.replicateStartDate)
    ) {
      updatedData.replicateEndDate = "";
    }

    dispatch(noticeAction.setReplicateNotice(updatedData));
  };

  const handlePageChange = (page) => {
    // setNoticeSearch((prevState) => ({
    //   ...prevState,
    //   pageNo: page,
    // }));

    const searchData = { ...noticeSearchdata };
    searchData.pageNo = page;
    searchData.facilityID = facilityCode;
    dispatch(noticeAction.setNoticeSearch(searchData));
    dispatch(noticeAction.noticeList(searchData))
  };

  const handleRowPerPage = (page) => {
    // setNoticeSearch((prevState) => ({
    //   ...prevState,
    //   rowCountPerPage: page,
    //   pageNo: 1,
    // }));
    const searchData = { ...noticeSearchdata };
    searchData.rowCountPerPage = page;
    searchData.pageNo = 1;
    searchData.facilityID = facilityCode;
    dispatch(noticeAction.setNoticeSearch(searchData));
    dispatch(noticeAction.noticeList(searchData))
  };

  const handleAddNotice = () => {
    Swal.close();
    dispatch(noticeAction?.resetForm());
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.NoticesMenuItem,
      })
    )
      .then((res) => {
        const shouldEnableAddOptions =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Add" && item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableAddOptions) {
          showToastNotification(
            "Add Notice option has been disabled by the admin.",
            "error"
          );
          return;
        }
        history.navigate("/Admin/NoticeList/AddEdit", {
          state: { noticeID: 0 },
        });
      })
      .catch((e) => { });
  };

  const navigateToNoticeEdit = (noticeID) => {
    Swal?.close();
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.NoticesMenuItem,
      })
    )
      .then((res) => {
        const shouldEnableModifyOptions =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Modify" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableModifyOptions) {
          showToastNotification(
            "Modify option has been disabled by the admin.",
            "error"
          );
          return;
        }
        history.navigate("/Admin/NoticeList/AddEdit", {
          state: { noticeID: noticeID },
        });
      })
      .catch((e) => { });
  };

  const handleDropdownChange = (selectedOption, name) => {
    const values = {
      ...noticeSearchdata,
      pageNo: 1,
      rowCountPerPage: 10,
      facilityID: facilityCode,
    };
    if (name === "kiosksID") {
      const State = selectedOption?.value || 0;
      values.kiosksID = State;
    } else {
      const statusValue = selectedOption?.value;
      values.activeStatus = statusValue ?? 2;
    }
    dispatch(noticeAction.setNoticeSearch(values));
    dispatch(noticeAction?.noticeList(values));
  };

  const handleChange = (e, type) => {
    // setNoticeSearch({
    //   ...noticeSearch,
    //   [type]: e ? fDate(e) : "",
    // });
    const searchParams = { ...noticeSearchdata };
    searchParams[type] = e ? fDate(e) : "";
    dispatch(noticeAction.setNoticeSearch(searchParams));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && noticeSearchdata[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleBlurDate = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "startDate") {
      if (
        noticeSearchdata.endDate &&
        new Date(value) > new Date(noticeSearchdata.endDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "endDate") {
      if (
        noticeSearchdata.startDate &&
        new Date(value) < new Date(noticeSearchdata.startDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    // const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate;

    let updatedParam = {
      ...noticeSearchdata,
      startDate:
        fieldName === "startDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : noticeSearchdata.startDate, // preserve existing value
      endDate:
        fieldName === "endDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : noticeSearchdata.endDate, // preserve existing value
    };

    // setNoticeSearch(updatedParam);
    dispatch(noticeAction.setNoticeSearch(updatedParam));
  };

  const exportDocAsExcel = () => {
    let generateExcelColumns = ["Title", "Start From", "End By", "Status"];

    const updateTotalRows = {
      ...noticeSearchdata,
      rowCountPerPage: noticeListResponse?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    dispatch(noticeAction?.noticeList(updateTotalRows))
      .then((result) => {
        const dataList = result?.payload?.DataList;
        let exportData =
          result &&
          dataList?.map((obj) => ({
            Title: obj?.NoticeTitle,
            "Start From": obj?.StartDate,
            "End By": obj?.EndDate,
            Status: obj?.ActiveStatus,
          }));
        generateXlsx(exportData, generateExcelColumns, "Notice List");
      })
      .catch((err) => {
        showToastNotification("Error in Export Data", "error");
      });
  };

  const handleExportNotice = (row) => {
    setExportSelectAll(null);
    setErrorMessage({});
    if (facilityCode === 0) return;
    dispatch(noticeAction?.resetForm());
    const replicateInfo = { ...replicateNoticeData };
    if (row) {
      replicateInfo.noticeID = row?.NoticeID;
      replicateInfo.startDate = row?.StartDate;
      replicateInfo.endDate = row?.EndDate;
      replicateInfo.replicateStartDate = row?.StartDate;
      replicateInfo.replicateEndDate = row?.EndDate;
      dispatch(noticeAction?.setReplicateNotice(replicateInfo));
    }
    dispatch(noticeAction?.exportNotices(facilityCode));
  };

  const handleMultiSelectChange = (selectedOptions = []) => {
    if (!Array.isArray(selectedOptions)) return;

    const updatedNoticeData = {
      ...exportNoticeData,
      noticeToFacilityList: selectedOptions.map((option) => ({
        toFacilityID: option?.FacilityID || null,
        FacilityCode: option?.FacilityCode || "",
      })),
    };

    dispatch(noticeAction.setExportNoticeData(updatedNoticeData));
  };

  const handlereplicateMultiSelectChange = (selectedOptions = []) => {
    if (!Array.isArray(selectedOptions)) return;
    setErrorMessage((prev) => ({
      ...prev,
      FacilityCode: "",
    }));
    const updatedNoticeData = {
      ...replicateNoticeData,
      noticeReplicateFacilityList: selectedOptions.map((option) => ({
        facilityID: option?.FacilityID || null,
        action: 1,
      })),
    };

    dispatch(noticeAction?.setReplicateNotice(updatedNoticeData));
  };

  const handleExportNoticePopup = (e, i, row) => {
    const { name, checked } = e?.target;
    const exportNoticeForList = [...facilityListForExportNotice?.DataList];
    const exportNoticeForAPI = { ...exportNoticeData };
    if (name === "exportFacilityselectAll") {
      setExportSelectAll(checked);

      //select all
      // const forList = [];
      // const forExport = [];
      // exportNoticeForList?.map((item) => {
      //   forList.push({
      //     toFacilityID: item?.FacilityID,
      //     FacilityName: item?.FacilityName,
      //     isActive: checked,
      //   });
      //   if (checked) {
      //     forExport?.push({
      //       toFacilityID: item?.FacilityID,
      //     });
      //   } else {
      //     return [];
      //   }
      // });
      const updatedList = exportNoticeForList.map((item) => ({
        ...item,
        isActive: checked,
      }));

      const selectedFacilities = checked
        ? updatedList.map((item) => ({ toFacilityID: item.FacilityID }))
        : [];

      dispatch(noticeAction?.updateExportData(updatedList));
      exportNoticeForAPI.noticeToFacilityList = selectedFacilities;
      dispatch(noticeAction?.setExportNoticeData(exportNoticeForAPI));
      return;
    } else {
      //single select
      let selectedArr = [];
      const updatedData = exportNoticeForList?.map((item, index) => {
        if (i === index) {
          if (checked) {
            selectedArr = [
              ...selectedExport,
              { toFacilityID: item?.FacilityID },
            ];
            setSelectedExport(selectedArr);
          } else {
            selectedArr = selectedExport?.filter(
              (item, i) => item?.toFacilityID !== row?.FacilityID
            );
            setSelectedExport(selectedArr);
          }
          return { ...item, isActive: checked };
        }
        return item;
      });
      dispatch(noticeAction?.updateExportData(updatedData));

      exportNoticeForAPI.noticeToFacilityList = selectedArr;
      dispatch(noticeAction?.setExportNoticeData(exportNoticeForAPI));
    }
  };

  const handleReplicateNoticePopup = (e, i, row) => {
    const { name, checked } = e?.target;
    const exportNoticeForList = [...facilityListForExportNotice?.DataList];
    const exportNoticeForAPI = { ...replicateNoticeData };

    if (name === "exportFacilityselectAll") {
      setExportSelectAll(checked);

      // Ensure all items remain visible and their state updates correctly
      const updatedList = exportNoticeForList.map((item) => ({
        ...item,
        isActive: checked,
      }));

      // Create the selected facilities list
      const selectedFacilities = checked
        ? updatedList.map((item) => ({
          facilityID: item.FacilityID,
          action: 1,
        }))
        : [];

      dispatch(noticeAction?.updateExportData(updatedList));
      exportNoticeForAPI.noticeReplicateFacilityList = selectedFacilities;
      dispatch(noticeAction?.setReplicateNotice(exportNoticeForAPI));

      return;
    } else {
      // Single select logic
      let selectedArr = [];
      const updatedData = exportNoticeForList.map((item, index) => {
        if (i === index) {
          if (checked) {
            selectedArr = [
              ...selectedExport,
              { facilityID: item?.FacilityID, action: 1 },
            ];
            setSelectedExport(selectedArr);
          } else {
            selectedArr = selectedExport.filter(
              (selectedItem) => selectedItem?.facilityID !== row?.FacilityID
            );
            setSelectedExport(selectedArr);
          }
          return { ...item, isActive: checked };
        }
        return item;
      });

      dispatch(noticeAction?.updateExportData(updatedData));
      exportNoticeForAPI.noticeReplicateFacilityList = selectedArr;
      dispatch(noticeAction?.setReplicateNotice(exportNoticeForAPI));
    }
  };

  const handleFormSubmit = (e) => {
    e?.preventDefault();
    const updatedObj = {
      ...noticeSearchdata,
      facilityID: facilityCode,
      rowCountPerPage: 10,
      pageNo: 1,
    };
    dispatch(noticeAction.setNoticeSearch(updatedObj));
    dispatch(noticeAction.noticeList(updatedObj));
  };

  const handleReset = () => {
    const resetSearch = {
      facilityID: facilityCode,
      kiosksID: 0,
      startDate: "",
      endDate: "",
      activeStatus: 2,
      pageNo: 1,
      rowCountPerPage: 10,
      sortBy: "",
    };

    //  dispatch(noticeAction.resetNoticeSearch());
    dispatch(noticeAction.noticeList(resetSearch));
    // setNoticeSearch(resetSearch);
    dispatch(noticeAction.setNoticeSearch(resetSearch));
  };

  const handleDelete = (id) => {
    if (id === 0) return;
    Popup({
      title: "Delete",
      text: `Are you sure you want to delete this notice?`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => deleteNoticeList(id, loggedUser?.ManagementUserID),
    });
  };

  const deleteNoticeList = (id, createdBy) => {
    // dispatch(noticeAction?.deleteNotice((id, createdBy)));
    dispatch(noticeAction?.deleteNotice({ noticeID: id, createdBy }));
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: facilityCode,
        ProcedureName: StoredProcedures?.NoticeDelete,
        UserAction: `Delete Notice (Notice ID - ${id} )`,
      })
    );
  };

  const submitExportNotice = (e) => {
    e?.preventDefault();
    if (exportNoticeData?.noticeToFacilityList?.length === 0) return;
    dispatch(noticeAction?.submitExportNotice({ ...exportNoticeData, fromFacilityID: facilityCode }));
    setExportSelectAll(false);
    setSelectedExport([]);
  };

  //onBlur Replicate Notice validateField
  const validateField = (fieldName, selectedValues) => {

    if (fieldName == "replicateStartDate" || fieldName == "replicateEndDate") {
      let { value } = selectedValues.target;
      let isFromValid = true;
      let isToValid = true;
      const data = { ...replicateNoticeData };
      if (fieldName === "replicateStartDate") {
        if (data.replicateEndDate && new Date(value) > new Date(data.replicateEndDate)) {
          // Invalid: FromDate cannot be after ToDate
          isFromValid = false;
        }
      } else if (fieldName === "replicateEndDate") {
        if (data.replicateStartDate && new Date(value) < new Date(data.replicateStartDate)) {
          // Invalid: ToDate cannot be before FromDate
          isToValid = false;
        }
      }

      const minDate = MinDate();
      const valueDate = new Date(value);
      const isValidDate = valueDate >= minDate;

      let updatedParam = {
        ...data,
        replicateStartDate:
          fieldName === "replicateStartDate"
            ? isFromValid && isValidDate
              ? value
              : ""
            : data.replicateStartDate, // preserve existing value
        replicateEndDate:
          fieldName === "replicateEndDate"
            ? isToValid && isValidDate
              ? value
              : ""
            : data.replicateEndDate, // preserve existing value
      };

      dispatch(noticeAction?.setReplicateNotice(updatedParam));

      const dataToValidate = { [fieldName]: updatedParam[fieldName] };

      const { error } = noticeListSchema(dataToValidate);

      if (error?.details) {
        const fieldError = error.details.find((err) =>
          err.path.includes(fieldName)
        );

        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          [fieldName]: fieldError ? fieldError.message : "",
        }));
      } else {
        setErrorMessage({});
        document.querySelectorAll(`[name="${fieldName}"]`).forEach((element) => {
          element.classList.remove("input-error");
        });
      }

    }
    else {
      const dataToValidate = { [fieldName]: selectedValues, };

      const { error } = noticeListSchema(dataToValidate);

      if (error?.details) {
        const fieldError = error.details.find((err) =>
          err.path.includes(fieldName)
        );

        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          [fieldName]: fieldError ? fieldError.message : "",
        }));
      } else {
        setErrorMessage({});
        document.querySelectorAll(`[name="${fieldName}"]`).forEach((element) => {
          element.classList.remove("input-error");
        });
      }
    }

  };

  const submitReplicateNotice = (e) => {
    e.preventDefault();

    if (replicateNoticeData?.noticeReplicateFacilityList?.length === 0) return;

    setSubmit(true);
    setErrorMessage({});

    document.querySelectorAll(".input-error").forEach((element) => {
      element.classList.remove("input-error");
    });

    // Validate input using noticeSchema
    const { error } = noticeListSchema({
      ...replicateNoticeData,
      FacilityCode: replicateNoticeData?.noticeReplicateFacilityList,
    });
    if (error?.details) {
      setSubmit(false);

      const updatedErrors = {};
      error.details.forEach((err) => {
        const field = err.path.join(".");
        updatedErrors[field] = err.message;

        const inputElement = document.querySelector(`[name="${field}"]`);
        if (inputElement) {
          inputElement.classList.add("input-error");
        }
      });

      setErrorMessage(updatedErrors);
      return;
    }

    const replicateNoticeparams = {
      noticeID: replicateNoticeData?.noticeID,
      startDate: replicateNoticeData?.replicateStartDate,
      endDate: replicateNoticeData?.replicateEndDate,
      createdBy: replicateNoticeData?.createdBy,
      isSucceed: replicateNoticeData?.isSucceed,
      noticeReplicateFacilityList: replicateNoticeData?.noticeReplicateFacilityList,
    };

    dispatch(noticeAction?.replicateNotices(replicateNoticeparams)).then((x) => {
      // Close modal only if the API call is successful
      const modalElement = document.getElementById("replicate-notices");
      if (modalElement) {
        modalElement.classList.remove("show");
        modalElement.style.display = "none";
        document.body.classList.remove("modal-open");
        document.querySelector(".modal-backdrop")?.remove();
      }
    });

    dispatch(noticeAction?.resetResponse());
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    const search = { ...noticeSearchdata };
    const newSortOrder = search.sortBy?.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    dispatch(noticeAction?.setNoticeSearch(search));
    dispatch(
      noticeAction.noticeList({
        ...noticeSearchdata,
        sortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading) return <CustomLoader />;

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleFormSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                options={KIOSKDropDownResponse}
                name="kiosksID"
                label="Kiosks"
                value={noticeSearchdata?.kiosksID}
                handleChange={(e) => handleDropdownChange(e, "kiosksID")}
                isClearable={noticeSearchdata?.kiosksID !== 0}
                placeholder="-- Select --"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                options={podStatusOptions}
                name="activeStatus"
                label="Status"
                value={noticeSearchdata?.activeStatus}
                handleChange={(e) => handleDropdownChange(e, "activeStatus")}
                isClearable={noticeSearchdata?.activeStatus !== 2}
                placeholder="Select Status"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <DateInput
                label="Start From"
                name="startDate"
                value={noticeSearchdata?.startDate}
                maxDate={noticeSearchdata?.endDate}
                handleChange={(e) => handleChange(e, "startDate")}
                placeholderText="Select a date"
                isClearable={noticeSearchdata?.startDate ? true : false}
                handleBlur={(e) => handleBlurDate(e, "startDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "startDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <DateInput
                label="End By"
                name="endDate"
                value={noticeSearchdata?.endDate}
                minDate={noticeSearchdata?.startDate}
                handleChange={(e) => handleChange(e, "endDate")}
                placeholderText="Select a date"
                isClearable={noticeSearchdata?.endDate ? true : false}
                handleBlur={(e) => handleBlurDate(e, "endDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "endDate")}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"Submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />
          <Button
            variant="secondary"
            className="me-2"
            onClick={handleReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <>
      {facilityCode > 0 ? (
        <div>
          <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
              {/* <div className="mb-3">
              <h2 className="form_title_uppercase text-color">Notice search</h2>
            </div> */}
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    Notice search
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none mt-2">
                {showSearchFields && renderSearch()}
              </div>

              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <h2 className="form_title_uppercase text-color">
                  Notice search
                </h2>
              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>
            </div>

            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-2">
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
                <h2 className="form_title_uppercase text-color">
                  Notices LIST
                </h2>
                <div className="d-flex flex-wrap align-items-center gap-3">
                  {shouldShowBtnAdd && (
                    <Button
                      variant="success"
                      className="me-2"
                      // onClick={() => history.navigate("/Admin/FacilityList/AddEdit")}
                      onClick={handleAddNotice}
                      label="Add Notice"
                      type="button"
                      status="btn-label"
                      disabled={false}
                      //  icon={"circle-plus"}
                      imgsrc={AddIcon}
                    />
                  )}
                  {user.UserRoleID === UserRoleType.SuperAdmin &&
                    noticeListResponse?.DataList?.length > 0 && (
                      <div
                        data-bs-toggle="modal"
                        data-bs-target="#export-notices"
                      >
                        <Button
                          variant="secondary"
                          className="me-2"
                          onClick={() => {
                            handleExportNotice();
                            setIsClearable(false);
                          }}
                          label={"Export Notices"}
                          type={"button"}
                          icon={"fa-solid fa-file-import"}
                          status={"btn-label"}
                          disabled={false}
                        />
                      </div>
                    )}

                  {noticeListResponse?.DataList?.length > 0 && (
                    <ExcelExport
                      variant="soft-gray"
                      handleExcelExport={exportDocAsExcel}
                    />
                  )}
                </div>
              </div>

              <Table
                columns={columns}
                data={noticeListResponse?.DataList}
                totalRowCount={noticeListResponse?.TotalRecordCount}
                pagination={true}
                currentPage={noticeSearchdata?.pageNo}
                paginationPerPage={noticeSearchdata?.rowCountPerPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleRowPerPage}
                onSort={handleSort}
                serverSideSort
                sortColumn={noticeSearchdata?.sortBy?.split(" ")[0]}
                sortDirection={noticeSearchdata?.sortBy?.split(" ")[1]}
              />
            </div>
            {/* )} */}

            <div className="Import Notices">
              <CommonModal
                modalId="export-notices"
                title="Import Notices"
                loader={exportNoticeData?.loading}
                handleCloseIcon={() => {
                  setIsClearable(true);
                }}
                bodyContent={
                  <div
                    style={{ minHeight: "400px", height: "400px" }}
                    className="shadow-sm p-3 rounded overflow-auto"
                  >
                    <MultiSelectDropdown
                      options={facilityListForExportNotice?.DataList}
                      displayValue="FacilityCode"
                      handleChange={(selectedOption) =>
                        handleMultiSelectChange(selectedOption)
                      }
                      placeholder="Choose Facility"
                      label={"Choose Facility"}
                      required={true}
                      isClearable={isClearable}
                    />
                  </div>
                }
                footerContent={
                  <>
                    <button
                      className="btn button-success"
                      data-bs-dismiss="modal"
                      onClick={() => submitExportNotice()}
                      disabled={
                        exportNoticeData?.noticeToFacilityList?.length === 0
                      }
                    >
                      Submit
                    </button>
                    <button
                      className="btn button-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setIsClearable(true);
                        setErrorMessage({});
                      }}
                    >
                      Close
                    </button>
                  </>
                }
              />
            </div>
            <div className="Replicate Notice">
              <CommonModal
                modalId="replicate-notices"
                title="Replicate Notice"
                // loader={exportNoticeData?.loading}
                handleCloseIcon={() => {
                  setErrorMessage({});
                  setisreplicateClearable(true);
                  document
                    .querySelectorAll(".input-error")
                    .forEach((element) => {
                      element.classList.remove("input-error");
                    });
                }}
                bodyContent={
                  <div>
                    <div>
                      <div
                        style={{ height: "550px" }}
                        className="shadow-sm p-3 rounded overflow-auto"
                      >
                        <div className="mt-1">
                          <MultiSelectDropdown
                            options={facilityListForExportNotice?.DataList}
                            displayValue="FacilityCode"
                            handleChange={(selectedOption) =>
                              handlereplicateMultiSelectChange(selectedOption)
                            }
                            placeholder="Choose Facility"
                            label="Choose Facility"
                            required={true}
                            onBlur={(selectedValues) =>
                              validateField("FacilityCode", selectedValues)
                            }
                            errorMessage={
                              errorMessage["FacilityCode"] ? errorMessage : []
                            }
                            islabelfunction={true}
                            isClearable={isreplicateClearable}
                          />
                        </div>
                        <div className="mt-3">
                          <DatePickerComponent
                            label="Start Date"
                            name="replicateStartDate"
                            value={
                              replicateNoticeData?.replicateStartDate
                                ? new Date(
                                  replicateNoticeData.replicateStartDate
                                )
                                : null
                            }
                            maxDate={
                              replicateNoticeData?.replicateEndDate
                                ? new Date(replicateNoticeData.replicateEndDate)
                                : undefined
                            }
                            minDate={new Date(1900, 0, 1)}
                            handleChange={(date) =>
                              handleChangeForDate("replicateStartDate", date)
                            }
                            handleBlur={(e) => validateField("replicateStartDate", e)}
                            placeholderText="Select a start date"
                            required={true}
                            disabled={false}
                            yearDropDown={true}
                            monthDropDown={true}
                            showTimeSelect={false}
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            onCut={(e) => e.preventDefault()}
                            isClearable={true}
                            errorMessage={errorMessage}
                            handleKeyDown={(e) => handleEnterKey(e, "replicateStartDate")}
                          />
                        </div>
                        <div className="mt-3">
                          <DatePickerComponent
                            label="End Date"
                            name="replicateEndDate"
                            value={
                              replicateNoticeData?.replicateEndDate
                                ? new Date(replicateNoticeData.replicateEndDate)
                                : null
                            }
                            minDate={
                              replicateNoticeData?.replicateStartDate
                                ? new Date(
                                  replicateNoticeData.replicateStartDate
                                )
                                : undefined
                            }
                            handleChange={(date) =>
                              handleChangeForDate("replicateEndDate", date)
                            }
                            handleBlur={(e) => validateField("replicateEndDate", e)}
                            placeholderText="Select an end date"
                            required={true}
                            disabled={false}
                            yearDropDown={true}
                            monthDropDown={true}
                            showTimeSelect={false}
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            onCut={(e) => e.preventDefault()}
                            isClearable={true}
                            errorMessage={errorMessage}
                            handleKeyDown={(e) => handleEnterKey(e, "replicateStartDate")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                footerContent={
                  <div className="mb-4 ">
                    <button
                      className="btn button-success me-3"
                      onClick={(e) => submitReplicateNotice(e)}
                      disabled={
                        replicateNoticeData?.noticeReplicateFacilityList
                          ?.length === 0
                      }
                    >
                      Submit
                    </button>
                    <button
                      className="btn button-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setisreplicateClearable(true);
                        setErrorMessage({});
                        document
                          .querySelectorAll(".input-error")
                          .forEach((element) => {
                            element.classList.remove("input-error");
                          });
                      }}
                    >
                      Close
                    </button>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </>
  );
}

export default React.memo(NoticeList);
